import { PaymentFoundationTrusteeActionTypes, PaymentFoundationTrusteeActions } from './payment-foundation-trustee.actions';
import { IPaymentFoundationTrustee } from '../../../commons';

export interface State {
    error: string | null;
    pending: boolean;
    stateData: IPaymentFoundationTrustee[] | null;
    processedData: IPaymentFoundationTrustee[] | null;
}

export const initialState: State = {
    error: null,
    pending: false,
    stateData: null,
    processedData: null
};

export function reducer(state = initialState, action: PaymentFoundationTrusteeActions): State {
    switch (action.type) {

        case PaymentFoundationTrusteeActionTypes.LoadPaymentFoundationTrusteeState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case PaymentFoundationTrusteeActionTypes.ProcessPaymentFoundationTrustee: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case PaymentFoundationTrusteeActionTypes.UpdateToCheckIssueFoundationTrustee: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }
        

        case PaymentFoundationTrusteeActionTypes.LoadPaymentFoundationTrusteeStateSuccess: {
            return {
                ...state,
                error: null,
                // pending: action.payload === null || state.processedData === null,
                stateData: action.payload
            };
        }

        case PaymentFoundationTrusteeActionTypes.LoadProcessedPaymentFoundationTrusteeState: {
            return {
                ...state,
                error: null,
                pending: true
            };
        }

        case PaymentFoundationTrusteeActionTypes.LoadProcessedPaymentFoundationTrusteeStateSuccess: {
            return {
                ...state,
                error: null,
                pending:  action.payload === null || state.stateData === null,
                processedData: action.payload
            };
        }

        case PaymentFoundationTrusteeActionTypes.LoadPaymentFoundationTrusteeStateFail: {
            return {
                ...state,
                error: action.payload,
                pending: false
            };
        }

        case PaymentFoundationTrusteeActionTypes.PaymentFoundationTrusteeScreenErrorReset: {
            return {
                ...state,
                error: null,
                pending: false
            };
        } 

        default: {
            return state;
        }
    }
}

export const getError = (state: State) => state.error;
export const getPending = (state: State) => state.pending;
export const getStateData = (state: State) => state.stateData;
export const getProcessedData = (state: State) => state.processedData;
